import './App.css';
import FrontPage from './pages/main/FrontPage';
import Projects from './pages/Projects/Projects';

function App() {
  return (
    <div className="App">

      <div className="navbar">
        <ul className='all_links'>
          <li><a href="#Projects">Projects</a></li>
          <li><a href="#Projects">Gallary</a></li>
          <li><a href="https://www.instagram.com/izy.design4/">Contact</a></li>
        </ul>
        
      </div>
      <FrontPage></FrontPage>
      <Projects></Projects>
    </div>
  );
}

export default App;
